//import logo from './logo.svg';
import '../CSS/style.css';
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import ndjsonStream from 'can-ndjson-stream';
import strings from '../String';

axios.defaults.withCredentials = true;

function ReviewerChat() {

    const [messages, setMessages] = useState([]);
    const [checkedItems, setCheckedItems] = useState({});
  
    const getAllQuestions = async () => {
        try {
          
          //sessionStorage.setItem('token',sessionId);
          
          const response = await axios.get(`${strings.apiBaseUrl}/Review/getAllQuestionsforReview`);
          console.log(response.data);
          setMessages(response.data)
        } catch (error) {
          console.error("Error fetching session details:", error);
        }
      };

      useEffect(() => {
        getAllQuestions();
      }, []); 
    

      const handleCheckboxChange = (event) => {
        const { id, checked } = event.target;
        setCheckedItems((prev) => ({
          ...prev,
          [id]: checked,
        }));
      };

      const isAnyChecked = Object.values(checkedItems).some(Boolean);
  
  

 


  return (
   

    <>
    

<div class="theme-toggle">
    <input type="checkbox" class="sr-only" id="darkmode-toggle" />
    <label for="darkmode-toggle" class="toggle">
        <span>Toggle dark mode</span>
    </label>
</div>
<div class="hamburger"><span class="menu-toggle" onclick="toggleMenu()">toggle menu</span></div>
<div id="body-overlay"></div>
<div class="relative z-0 flex h-full w-full overflow-hidden">
    <div class="flex-shrink-0 overflow-x-hidden bg-token-sidebar-surface-primary w-300">
      

        <nav class="real-menu d-flex flex-column" role="navigation">
            <div class="sidebar-listIteam">
                <span class="closebtn close-btn" onclick="toggleMenu()">&times;</span>
                <a class="navbar-brand navbar-start" href="chat.html"><img alt="logo" id="logo-img" class="logo"
                        src="Img/cimatron-logo-720x177.png" /></a>
                        <br/>
                <ul class="review-options">
                    <li><span class="material-symbols-outlined">
                        help
                        </span> All Quesions</li>
                    {/* <li><span class="material-symbols-outlined">
                        share_reviews
                        </span> Assigning for Review</li> */}
                    <li><span class="material-symbols-outlined">
                        verified
                        </span> Reviewed</li>
                </ul>
                <div class="bottom-text">
                    <div class="btn-group dropup">
                        <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            <img alt="user-icon" src="Img/icon/icons8-user-48.png" width="40" height="auto"
                                class="pe-2" /> <span>User Name</span></a>
                        <ul class="dropdown-menu">
                            <li><button id="setting-btn" type="button" class="setting-btn" data-bs-toggle="modal"
                                    data-bs-target="#exampleModal">
                                    <span class="material-symbols-rounded">settings</span>Settings
                                </button></li>
                        </ul>
                    </div>
                    <div><a class="dropdown-item" href="/index.html"><img alt="user-icon"
                                src="Img/icon/icons8-logout.png" width="40" height="auto" class="pe-2" />
                            Logout</a></div>

                </div>
            </div>
        </nav>
    </div>
    <div id="questionAnwserContainer" class="flex h-full max-w-full flex-1 flex-col overflow-hidden px-5">
        <div class="fixbar">
            <div id="searchQue" class="searchQue">
                <a href="" target="_blank" hidden></a>
                <input id="search-input" type="text" placeholder="Search..." onkeyup="searchSuggestion(this)" />
                <div id="resultBox" class="resultBox">
                </div>
                <div class="icon"><span class="material-icons">
                        search
                    </span></div>
            </div>
        </div>
        <div class="accordion accordion--custom" id="accordionExample">
            <div class="accordion accordion-flush" id="accordionFlushExample">
                {messages.map((message) => (
                <div class="accordion-item">
                <h2 class="accordion-header" id={`flush-heading-${message.id}`}>
                  <input type="checkbox" class="form-check-input program_checkbox" id={message.id} onChange={handleCheckboxChange}  />
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapse-${message.id}`} aria-expanded="false" aria-controls={`#flush-collapse-${message.id}`}>
                  {message.request}
                  </button>
                </h2>
                <div id={`flush-collapse-${message.id}`} class="accordion-collapse collapse" aria-labelledby={`flush-heading-${message.id}`}>
                  <div class="accordion-body">
                      <p dangerouslySetInnerHTML={{ __html: message.response }}></p>
                      <div class="chat-icon-expert pt-2">
                          
                          <span onclick="copyResponse(this)" class="material-icons">content_copy</span>
                          <span id="comment-icon" class="material-icons" onclick="toggleSidebar(this)" title="Add Comments">add_comment</span>
                          </div>    
                  </div>
                </div>
              </div>
              ))}


              </div>
       </div>
    <div className={`footer-btn ${isAnyChecked ? '' : 'hidden'}`}>
       <div>
        <button type="button" class="btn btn-outline-primary">Mark as Reviwed</button>
       </div>
</div>

</div>
</div>




<div id="mySidenav" class="sidenav">
    <a href="javascript:void(0)" class="closebtn" onclick="closeNav()">&times;</a>

    <div class="container p-4">
        <h4>Comments</h4>
        <div id="add-comment">
            <form>
                <div class="form-group comment-textarea my-4">
                    <textarea class="form-control status-box" rows="3"
                        placeholder="Enter your comment here..."></textarea>
                </div>
            </form>
            <div class="button-group pull-right mt-3">
                
                <a href="#" id="comment-post" class="btn btn-primary comment-post">Post</a>
            </div>
        </div>
        <ul class="posts">
        </ul>
    </div>
</div>



<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Application Settting</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="seeting-theme-toogle">
                    <h6>Theme</h6>
                    <div class="theme-toggle">
                        <input type="checkbox" class="modal-only" id="modal-darkmode-toggle"/>
                        <label for="darkmode-toggle" class="toggle">
                            <span>Toggle dark mode</span>
                        </label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary">Save changes</button>
            </div>
        </div>
    </div>
</div>


    </>
  );
}















export default ReviewerChat;


